import { forwardRef, Fragment } from 'react';
import cn from 'classnames';

import { BaseProps } from '@/shared/types';
import { IconName } from '@/shared/uikit/Icon';

import {
  Container,
  Divider,
  ErrorIcon,
  IconWrapper,
  Item,
  StyledIcon,
  StyledText,
  TextWrapper,
} from './styled';

export type FormSidebarItem = {
  title: string;
  icon?: IconName;
  showActionButton?: boolean;
  isError?: boolean;
};

type FormSidebarProps = {
  items: FormSidebarItem[];
  step: number;
  setStep: (step: number) => void;
  setItemOpenState: (index: number, open: boolean) => void;
} & BaseProps;

export const FormSidebar = forwardRef<(HTMLDivElement | null)[], FormSidebarProps>(
  ({ items, step, setStep, setItemOpenState, className }, ref) => {
    const handleClick = (index: number) => {
      setStep(index);
      setItemOpenState(index, true);

      if (ref && 'current' in ref && ref.current) {
        const currentSection = ref.current[index];
        currentSection?.scrollIntoView();
      }
    };

    return (
      <Container className={cn(className)}>
        {items.map((item, index) => (
          <Fragment key={index}>
            <>
              {item.icon && index !== 0 && <Divider />}
              {item.icon && (
                <Item onClick={() => handleClick(index)} className={cn({ active: step === index })}>
                  <IconWrapper>
                    <StyledIcon name={item.icon} size="s24" />
                  </IconWrapper>
                  <TextWrapper>
                    <StyledText className={cn({ bold: step === index })}>{item.title}</StyledText>
                  </TextWrapper>
                  {item.isError && <ErrorIcon />}
                </Item>
              )}
            </>
          </Fragment>
        ))}
      </Container>
    );
  },
);

FormSidebar.displayName = 'FormSidebar';
